<template>
  <div v-if="show" class="job-personality-calibration">
    <div class="description-container">
      <div v-for="(message, index) in $t(`${i18nPrefix}.message.personalityCalibrationDesc`)" class="description" :key="index">{{ message }}</div>
    </div>
    <div class="calibration-container">
      <div
        v-for="(personality, index) in personalityList"
        class="personality-calibration"
        :key="index"
      >
        <div class="personality" :class="personality.typeName">
          <div class="personality-image-wrapper">
            <div class="personality-image"></div>
          </div>
          <div class="personality-desc">
            <b>{{ personality.description.title }}:</b>
            <span> {{ personality.description.content }}</span>
          </div>
        </div>
        <div class="calibration">
          <el-checkbox
            v-for="(calibration, index) in calibrationList"
            class="calibration-checkbox"
            :key="index"
            :class="calibration.typeName"
            :disabled="disabled"
            :value="stepData[personality.typeName][calibration.typeName]"
            @change="handleCalibrationChange(personality, calibration)"
          >{{ $t(`${i18nPrefix}.btn.calibration.${calibration.typeName}`) }}</el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import mixin from './mixin'

const PERSONALITY_TYPE = {
  COMPOSURE: 'composure',
  RESILIENCE: 'resilience',
  TEAMWORK: 'teamwork',
  OUTGOING: 'outgoing',
  LEADERSHIP: 'leadership',
  MENTAL_AGILITY: 'mentalagility',
  ORGANIZING: 'organizing',
  DRIVE: 'drive',
  SERVICING: 'servicing',
  SELLING: 'selling'
}

const CALIBRATION_TYPE = {
  HEIGHT: 2,
  MIDDLE: 1,
  LOW: 0
}

const HEIGHT_CALIBRATION_NAME = _.findKey(CALIBRATION_TYPE, (type) => type === CALIBRATION_TYPE.HEIGHT)
const MIDDLE_CALIBRATION_NAME = _.findKey(CALIBRATION_TYPE, (type) => type === CALIBRATION_TYPE.MIDDLE)
const LOW_CALIBRATION_NAME = _.findKey(CALIBRATION_TYPE, (type) => type === CALIBRATION_TYPE.LOW)

const defaultPersonalityCalibration = {}
const defaultCalibration = {}
_.forEach(CALIBRATION_TYPE, (type, typeName) => {
  defaultCalibration[typeName] = false
})
_.forEach(PERSONALITY_TYPE, (type, typeName) => {
  defaultPersonalityCalibration[typeName] = { ...defaultCalibration }
})

export default {
  mixins: [mixin],
  components: {

  },
  data () {
    return {
      CALIBRATION_TYPE,
      hasForm: false,
      stepData: { ...defaultPersonalityCalibration },
      disabledPersonalityCalibration: { ...defaultPersonalityCalibration }
    }
  },
  computed: {
    personalityList () {
      return _.map(PERSONALITY_TYPE, (type, typeName) => {
        return {
          type,
          typeName,
          description: this.$t(`${this.i18nPrefix}.personalityDescription.${typeName}`)
        }
      })
    },
    calibrationList () {
      return _.map(CALIBRATION_TYPE, (type, typeName) => {
        return {
          type,
          typeName
        }
      })
    }
  },
  created () {

  },
  methods: {
    handleCalibrationChange (personality, calibration) {
      const personalityName = personality.typeName
      const personalityCalibration = this.stepData[personalityName]
      const calibrationName = calibration.typeName
      const disabled = this.disabledPersonalityCalibration[personalityName][calibrationName]
      if (disabled) {
        const checkedCount = _.countBy(personalityCalibration).true
        const errorType = checkedCount === 1 ? 'calibrationNeedAtLastOne' : 'calibrationCannotOnlyHeightAndLow'
        this.$message.error(this.$t(`${this.i18nPrefix}.message.${errorType}`))
        return
      }
      personalityCalibration[calibrationName] = !personalityCalibration[calibrationName]
      const checkedCalibrations = []
      _.forEach(personalityCalibration, (checked, calibration) => {
        checked && checkedCalibrations.push(calibration)
      })
      const disabledCalibration = { ...defaultCalibration }
      if (checkedCalibrations.length === 1) {
        const checkedCalibration = checkedCalibrations[0]
        disabledCalibration[checkedCalibration] = true
      } else if (checkedCalibrations.includes(HEIGHT_CALIBRATION_NAME) && checkedCalibrations.includes(LOW_CALIBRATION_NAME)) {
        personalityCalibration[MIDDLE_CALIBRATION_NAME] = true
        disabledCalibration[MIDDLE_CALIBRATION_NAME] = true
      }
      this.disabledPersonalityCalibration[personalityName] = disabledCalibration
    },
    setStepDataToJobInfo () {
      const stepData = this.stepData
      const jobInfo = this.jobInfo
      const jobCalibration = {}
      _.forEach(PERSONALITY_TYPE, (type, typeName) => {
        const calibration = jobCalibration[type] = []
        _.forEach(stepData[typeName], (isChecked, calibrationTypeName) => {
          if (isChecked) {
            calibration.push(CALIBRATION_TYPE[calibrationTypeName])
          }
        })
      })
      this.$set(jobInfo, 'culture', jobCalibration)
    },
    async getStepData () {
      const jobInfo = this.jobInfo
      const stepData = {}
      const jobCalibration = jobInfo.culture || {}

      const disabledPersonalityCalibration = {}
      _.forEach(PERSONALITY_TYPE, (type, typeName) => {
        const calibration = jobCalibration[type] || [CALIBRATION_TYPE.MIDDLE]
        const personalityCalibration = stepData[typeName] = {}
        _.forEach(CALIBRATION_TYPE, (type, typeName) => {
          personalityCalibration[typeName] = calibration.includes(type)
        })
        const disabledCalibration = disabledPersonalityCalibration[typeName] = { ...defaultCalibration }
        if (calibration.length === 1) {
          const checkedCalibration = _.findKey(personalityCalibration)
          disabledCalibration[checkedCalibration] = true
        } else if (calibration.length === 3) {
          disabledCalibration[MIDDLE_CALIBRATION_NAME] = true
        }
      })
      this.disabledPersonalityCalibration = disabledPersonalityCalibration
      return stepData
    }
  }
}
</script>

<style lang="scss" scoped>
.job-personality-calibration {
  .description-container {
    margin: -35px -50px 25px;
    font-size: 16px;
    color: #666;

    .description {
      + .description {
        margin-top: 10px;
      }
    }
  }

  .calibration-container {
    display: flex;
    margin-top: 25px;
    flex-flow: row wrap;
    justify-content: space-between;

    .personality-calibration {
      display: flex;
      width: 49%;
      min-height: 150px;
      margin-bottom: 10px;
      border: 1px solid #DCDFE6;
      border-radius: 20px;

      .personality {
        flex: 1;
        display: flex;
        padding: 15px 10px;
        border-right: 1px solid #DCDFE6;

        .personality-image-wrapper {
          margin-right: 15px;

          .personality-image {
            width: 70px;
            height: 70px;
            background-repeat: no-repeat;
          }
        }

        .personality-desc {
          flex: 1;

          b {
            font-size: 15px;
          }

          span {
            color: #666;
          }
        }
      }

      .calibration {
        display: flex;
        padding: 0 10px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .calibration-checkbox {
          display: block;
          width: 70px;
          margin: 0;
          padding: 5px 0;
        }
      }
    }
  }

  .COMPOSURE {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/composure.png);
    }
  }

  .RESILIENCE {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/resilience.png);
    }
  }

  .TEAMWORK {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/teamwork.png);
    }
  }

  .OUTGOING {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/outgoing.png);
    }
  }

  .LEADERSHIP {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/leadership.png);
    }
  }

  .MENTAL_AGILITY {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/mentalAgility.png);
    }
  }

  .ORGANIZING {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/organizing.png);
    }
  }

  .DRIVE {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/drive.png);
    }
  }

  .SERVICING {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/servicing.png);
    }
  }

  .SELLING {
    .personality-image {
      background-image: url(~@/assets/image/personalityCalibration/selling.png);
    }
  }
}

.page-en {
  .job-personality-calibration {
    .calibration-container {
      .personality-calibration {
        .calibration {
          .calibration-checkbox {
            text-align: left;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
